export const getLifeWheelColor = () => {
    const colorMap1 = {
        "Expression, Acceptance, Responsibility": "#77D1EB",
        "Influence, Empowerment, Credibility": "#5B9AC8",
        "Aspiration, Ownership, Optimization": "#F39F9C",
        "Outspokenness, Concern, Authenticity": "#F3BF77",
        "Urge to Learn, Openness, Initiative": "#96D6B6"
    };

    const colorMap2 = {
        "Expression, Acceptance, Responsibility": "#2DB2D9",
        "Influence, Empowerment, Credibility": "#15598B",
        "Aspiration, Ownership, Optimization": "#E97975",
        "Outspokenness, Concern, Authenticity": "#DB9B43",
        "Urge to Learn, Openness, Initiative": "#59A27E"
    };
    const colorMap3 = {
        "Expression, Acceptance, Responsibility": "#1d7b9c",
        "Influence, Empowerment, Credibility": "#0d3f60",
        "Aspiration, Ownership, Optimization": "#a53938",
        "Outspokenness, Concern, Authenticity": "#8d6d27",
        "Urge to Learn, Openness, Initiative": "#3b7054"
    };

    const lifeWheelColorMappedToOrientation = {
        "Achievement": "Aspiration, Ownership, Optimization",
        "Leadership": "Influence, Empowerment, Credibility",
        "Relationship": "Expression, Acceptance, Responsibility",
        "Learning": "Urge to Learn, Openness, Initiative",
        "Nurturing": "Outspokenness, Concern, Authenticity"
    }

    return {
        colorMap1,
        colorMap2,
        colorMap3,
        lifeWheelColorMappedToOrientation
    }
}

export const getHubWheelColor = () => {
    const hubcolorMap1 = {
        "Sensitivity": "#77D1EB",
        "Task Involvement, People Involvement": "#5B9AC8",
        "Involvement": "#F39F9C",
        "Conviction": "#F3BF77",
        "Understanding, Integration": "#96D6B6",
    };

    const hubcolorMap2 = {
        "Sensitivity": "#2DB2D9",
        "Task Involvement, People Involvement": "#15598B",
        "Involvement": "#E97975",
        "Conviction": "#DB9B43",
        "Understanding, Integration": "#59A27E",
    };
    const hubcolorMap3 = {
        "Sensitivity": "#1d7b9c",
        "Task Involvement, People Involvement": "#0d3f60",
        "Involvement": "#a53938",
        "Conviction": "#8d6d27",
        "Understanding, Integration": "#3b7054",
    };

    const hubWheelColorMappedToOrientation = {
        "Achievement": "Involvement",
        "Leadership": "Task Involvement, People Involvement",
        "Relationship": "Sensitivity",
        "Learning": "Understanding, Integration",
        "Nurturing": "Conviction"
    }

    return {
        hubcolorMap1,
        hubcolorMap2,
        hubcolorMap3,
        hubWheelColorMappedToOrientation
    }
}








// WEBPACK FOOTER //
// ./src/new/Utils/colors.js